import React, { PropTypes, Component } from 'react';
import Rating from './Rating';
import Reviews from './Reviews';
import Notification from './Notification';

if (process.env.BROWSER) {
  require('../assets/css/goal.css');
  require('../assets/css/football.css');
}

class ProductEntity extends React.Component {
  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}

  }

  render() {
    const product = this.props.data;
    var specs = JSON.parse("[" + product[0].specs + "]");
    return (
      <div className="container-fluid" style={ { 'padding': '0px' } }>
        <div className="row-fluid clearfix">
          <div className="col-md-3">
          </div>
          <div className="col-md-9">
            <div className="container-fluid container-border">
              <div className="row-fluid">
                <div className="col-md-12">
                  <div className="category-breadcumb" style={ { paddingLeft: '0px' } }>
                    Home/product/
                    { product[0].display_name }
                  </div>
                  <div className="category-title" style={ { paddingLeft: '0px' } }>
                    <span style={ { 'float': 'left' } }>{ product[0].display_name }</span>
                    <div style={ { 'float': 'left' } }>
                      <Rating entities={ product[0] } />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row-fluid">
                <div className="goal">
                  <div className="goal-leftcontainer">
                    <img style={ { 'float': 'left' } } src={ "" + product[0].image_url } />
                    <div className="service-address">
                      <div style={ { 'font-weight': 'bold' } }>PRICE: <span style={ { 'font-weight': 'normal' } }>{ product[0].selling_price }</span>
                      </div>
                      <br/>
                      <div style={ { 'font-weight': 'bold' } }>TECHNICAL DETAILS:</div>
                      <br/>
                      { Object.keys(specs[0]).map(function(key) {
                          return (
                            <div>
                              { (key !== "Customer Reviews") && (
                                <div style={ { 'display': 'inline-block' } }>
                                  <div style={ { 'float': 'left', 'font-weight': 'bold' } }>
                                    { key }:</div>
                                  <div style={ { 'float': 'left' } }>
                                    { specs[0][key] }
                                  </div>
                                  <br/>
                                </div>
                                ) }
                            </div>
                            );
                        }) }
                    </div>
                  </div>
                </div>
              </div>
              <div className="row-fluid">
                <div className="col-md-8" style={ { borderRight: '1px solid #ccc' } }>
                  <div className="about">About</div>
                  <div className="about-content">
                    <div>
                      { product[0].description }
                    </div>
                  </div>
                  <div className="about-link">
                    <i className="icon-link"></i><a href={ "http://www." + product[0].name }>visit to { product[0].display_name }</a><span>|</span><i className="icon-share"></i><span>share</span>
                  </div>
                  <div className="item-padding">
                    <div className="category-border"></div>
                  </div>
                  <div className="review-title">
                    <span style={ { 'float': 'left' } }>review</span>
                    { (null !== product[0].review_description) && (
                      <div style={ { 'float': 'left', 'color': 'red' } }>(
                        { product.length })</div>
                      ) }
                    { (null === product[0].review_description) && (
                      <div style={ { 'float': 'left', 'color': 'red' } }>(0)</div>
                      ) }
                  </div>
                  <div className="review-container">
                    <Reviews entities={ product } />
                    <textarea rows="8" cols="80" className="review-writecontent" placeholder="write your reviews ..."></textarea>
                    <div className="review-detail">
                      { (null !== product[0].review_description) && (
                        <span style={ { paddingLeft: '0px' } }>{ product.length }review</span>
                        ) }
                      { (null === product[0].review_description) && (
                        <span style={ { paddingLeft: '0px' } }>NO REVIEWS</span>
                        ) }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="notify-container" style={ { 'margin': '20px' } }>
                    <Notification notifications={ [] } />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
}

module.exports = ProductEntity;


// WEBPACK FOOTER //
// ./src/components/ProductEntity.js